//require('./bootstrap');

require('@noardcode/compass-core')
require('@noardcode/compass-side-panels')
require('@noardcode/compass-tables')
require('@noardcode/compass-forms')
require('./form.js')

import * as noUiSlider from 'nouislider';
import 'nouislider/dist/nouislider.css';

import wnumb from 'wnumb';

window.noUiSlider = noUiSlider;
window.wNumb = wnumb;

